import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ImagesearchRollerIcon(props: IconProps) {
    return <Icon {...props} iconKey={"imagesearch_roller"}/>
}
